import React, { ReactElement, useState } from 'react';
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { Translate } from "react-redux-i18n";
import { Grid, TextField, Typography, Button, MenuItem } from '@mui/material';

import { NUMBER_REGEXP } from '../../../constants';
import { Attribute, Option, getPayMethodContentRequested } from 'redux/payments/paymentsSlice';
import styles from "./styles.module.scss";

export default function PaymentForm(): ReactElement {
  const dispatch = useAppDispatch();
  const method = useAppSelector(state => state.dialog.dialogData);
  const [payload, setPayload] = useState<Record<string, string> | Record<string, "">>({});
  const handleChange = (name: string, value: string) => {
    setPayload({
      ...payload,
      [name]: value
    })
  }
  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    payload &&
      dispatch(
        getPayMethodContentRequested({
          id: method.id,
          payloadData: payload
        }))
  }

  return (
    <form onSubmit={(e) => handleSubmit(e)} className={styles.form}>
      <Grid container spacing={1} direction="row" >
        <Typography className={styles.title}>
          {method.label.split(" ")[0]}&nbsp;<Translate value={`payments.${method.label.split(" ")[1].toLowerCase()}`} />
        </Typography>
        {method &&
          method["attributes"]
            .map((attr: Attribute) =>
              <Grid item xs={12} md={12} key={attr.name} >
                <TextField
                  select={attr.type === "selectfield" ? true : false}
                  name={attr.name}
                  value={payload[attr.name] || ""}
                  label={<Translate value={`payments.${attr.name}`} />}
                  size="small"
                  fullWidth
                  required
                  onChange={(event) => {
                    if (attr.input == "number") {
                      if (event.target.value == "" || NUMBER_REGEXP.test(event.target.value)) {
                        handleChange(event.target.name,
                          event.target.value.replace(",", ".")
                        )
                      }
                    } else {
                      handleChange(event.target.name, event.target.value)
                    }
                  }
                  }
                  className={[styles.label, "form-label"].join(" ")}
                >
                  {attr.options && attr.options.map((option: Option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
            )
        }
        <Grid item xs={12} md={12} className={styles.btnGridItem}>
          <Button
            type="submit"
            variant="contained"
            color="success"
            className={styles.proceedBtn}
          >
            <Typography className={styles.label}>
              <Translate value="buttons.proceed" />
            </Typography>
          </Button>
        </Grid>
      </Grid>
    </form>
  );
}